import * as React from 'react'

const automation = ({ color = '#001335', style }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <circle cx="8" cy="8" r="6" stroke={color} />
      <path d="M8.5 4.5L5.5 8.5H8L7.5 11.5L10.5 7.5H8L8.5 4.5Z" stroke={color} strokeLinejoin="round" />
    </svg>
  )
}

export default automation
